import * as React from "react";
import { IoCloseOutline } from "react-icons/io5";
import { Overlay } from "../Overlay/Overlay";

export interface IConfirmationDialogProps {
  closeCallback: () => void;
  icon: JSX.Element;
  title: JSX.Element | string;
  messageText: string;
  buttons: JSX.Element;
}

export interface IConfirmationDialogState {}

export default class ConfirmationDialog extends React.Component<
  IConfirmationDialogProps,
  IConfirmationDialogState
> {
  public render(): React.ReactElement<IConfirmationDialogProps> {
    return (
      <div>
        <Overlay isMenuOverlay={true} isDialogOverlay={false}>
          <div className={"closeIcon"}>
            {this.props.closeCallback ? (
              <IoCloseOutline onClick={() => this.props.closeCallback()} />
            ) : undefined}
          </div>
          <div className={"clearfix"}></div>
          <div>
            <div className={"iconContainer"}>{this.props.icon}</div>
            <div className={"titleContainer"}>{this.props.title}</div>
            <div className={"messageTextContainer"}>
              {this.props.messageText}
            </div>
            <div className={"buttonsContainer"}>{this.props.buttons}</div>
          </div>
        </Overlay>
      </div>
    );
  }
}
